






import Vue from 'vue'
import Component from 'vue-class-component'
import PlayerStat from '@/components/PlayerStat.vue'
import API from '@/utils/api'
@Component({
  components: { PlayerStat },
})
export default class PlayerStatTestView extends Vue {
  get playerId() {
    return parseInt(this.$route.params.playerId)
  }
}
